enum GestionTrimestreActions {
  NUMEROTATION = 'numerotation',
  DENUMEROTATION = 'denumerotation',
  RENUMEROTATION = 'renumerotation',
}

export default GestionTrimestreActions;
